export enum Rule {
	EQUAL = 'equal',
	IN = 'in',
	NOT_EQUAL = 'notEqual',
	STARTS_WITH = 'startsWith',
	NOT_STARTS_WITH = 'notStartsWith',
	FILLED = 'filled',
}
